import { useAuthStore } from '@/store/auth.store'
import { UserRole } from '@/types'
import { AdminDashboard } from './dashboards/admin-dashboard'
import { TeacherDashboard } from './dashboards/teacher-dashboard'
import { StudentDashboard } from './dashboards/student-dashboard'
import { ParentDashboard } from './dashboards/parent-dashboard'

export const Dashboard: React.FC = () => {
  const { user } = useAuthStore()

  if (!user) return null

  const roleDashboards: Record<UserRole, React.ComponentType> = {
    [UserRole.ADMIN]: AdminDashboard,
    [UserRole.TEACHER]: TeacherDashboard,
    [UserRole.STUDENT]: StudentDashboard,
    [UserRole.PARENT]: ParentDashboard,
  }

  const DashboardComponent = roleDashboards[user.role]

  return <DashboardComponent />
}
